import { createContext } from 'react';
export const MenuContext = createContext(null);
//# sourceMappingURL=menuContext.js.map